export const TEACHER_COMMAND_ALIASES: Record<string, string[]> = {
  ENTER_FULLSCREEN: ['fullscreen'],
  EXIT_FULLSCREEN: ['exit_fullscreen'],
  RESET_APP_DEFAULT_STATE: ['reset_to_default'],
  LOCK_SCREEN: ['lock'],
  UNLOCK_SCREEN: ['unlock'],
  WORDCLOUD_CLEAR_WORD_LIST: ['clear_words'],
  CALCOLA_CLEAR_DEMO_SHEET: ['clear_all'],
  CALCOLA_CLEAR_STUDENT_SHEETS: ['clear_student_sheets'],
  MOMAPPE_RESET_CANVAS: ['clear_canvas'],
  DISEGNA_CLEAR_CANVAS: ['clear_canvas'],
  SCACCHI_SET_MODE: ['set_mode'],
  VIBRA_LOCK_RESPONSES: ['lock_responses'],
  VIBRA_UNLOCK_RESPONSES: ['unlock_responses'],
  VIBRA_WHITE_SCREEN: ['white_screen'],
  VIBRA_MEDITATION_MODE: ['meditation_mode'],
};

const REVERSE_ALIASES: Record<string, string[]> = Object.entries(TEACHER_COMMAND_ALIASES).reduce(
  (acc, [canonical, aliases]) => {
    aliases.forEach((alias) => {
      if (!acc[alias]) acc[alias] = [];
      acc[alias].push(canonical);
    });
    return acc;
  },
  {} as Record<string, string[]>
);

export function getTeacherCommandCandidates(commandType: string): string[] {
  const canonicalAliases = TEACHER_COMMAND_ALIASES[commandType] ?? [];
  const reverseAliases = REVERSE_ALIASES[commandType] ?? [];
  return [commandType, ...canonicalAliases, ...reverseAliases];
}
